//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Mechatronics.js";
import "../no/Builder.js";
let d=[[[0,"AdapterIdentify",1,"Mechatronics.SignalAdapter",1],[0,"MATLABSignalName",1,1],[0,"MATLABSignalPort",1,1],[0,"MATLABSignalType",1,1],[0,"ModelName",1,1],[0,"ResultName",1,1],[0,"SignalIdentify",1,"NXObject",1],[0,"StreamIO",1,1]],[],[]];
SPLM.Mechatronics.MATLABSignalConnectionBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Mechatronics.MATLABSignalConnectionBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Mechatronics.MATLABSignalConnectionBuilder.DataType = Object.freeze({
    "Unknown" : "Unknown", "Int" : "Int", "Double" : "Double", "Bool" : "Bool", "String" : "String"});

export default SPLM;